import React from 'react';
import MainPage from './MainPage';

const Food = () => {
  return <MainPage tag='FOOD' title='FOOD_SELECTION' url='/food-selection'/>;
}

export default Food;